import { z } from 'zod';

export const vehicleConfigurationSchema = z.object({
  height: z.number(),
  width: z.number(),
  length: z.number(),
  weight: z.number(),
  maxWeightPerAxleGroup: z.number().optional(),
});

export type VehicleConfiguration = z.infer<typeof vehicleConfigurationSchema>;
